import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

const ImageModal = ({ ismodal, setIsModal, imagingdata }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  if (!ismodal || !imagingdata) return null;

  const handleZoomIn = () => setZoomLevel((prev) => prev + 0.2);
  const handleZoomOut = () => setZoomLevel((prev) => Math.max(prev - 0.2, 0.2));

  const handleCloseEnlarged = () => {
    setSelectedImage(null);
    setZoomLevel(1);
  };

  const renderData = (data) => {
    if (Array.isArray(data)) {
      return data.map((item, index) => (
        <div key={index} className="mb-6 border border-gray-300 p-4 rounded-lg">
       
          {renderData(item)}
        </div>
      ));
    }

    return (
      <div>
        {Object.entries(data).map(([key, value], index) => (
          <div key={index} className="mb-4 flex items-start">
            <strong className="capitalize text-gray-900 text-sm font-semibold mr-2">
              {key.replace(/([A-Z])/g, ' $1')}:
            </strong>
            {typeof value === 'object' ? (
              <div className="ml-2 border-l-4 border-gray-300 pl-4 space-y-3">
                {renderData(value)}
              </div>
            ) : (
              <span className="text-gray-700 text-sm">
                {value?.toString() || (
                  <span className="text-gray-400 italic font-light">N/A</span>
                )}
              </span>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      {/* Close button */}
      <div className="relative bg-white p-6 rounded-xl shadow-2xl w-full max-w-2xl overflow-y-auto max-h-[80vh] animate-fade-in custom-scrollbar">
        <button onClick={() => setIsModal(false)} className="absolute top-4 right-4 text-gray-500 hover:text-gray-800">
          <RxCross2 size={28} />
        </button>

        <h2 className="text-xl font-semibold text-gray-800 mb-6 text-start">Summary Details</h2>
        {imagingdata?.summary ? renderData(imagingdata.summary) : <p className="text-gray-500">No Summary Available</p>}

        {/* Images Section */}
        {imagingdata?.images?.length > 0 && (
          <div className="mt-6">
            <h3 className="text-xl text-start font-semibold text-gray-800 mb-4">Images</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {imagingdata.images.map((image, index) => (
                <img
                  key={index}
                  src={`data:${image[0]};base64,${image[1]}`}
                  alt={`Image ${index + 1}`}
                  className="rounded-lg shadow-md cursor-pointer hover:scale-105 transition-transform duration-300"
                  onClick={() => setSelectedImage(`data:${image[0]};base64,${image[1]}`)}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Enlarged Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex flex-col items-center justify-center z-[60]">
          {/* Controls Header */}
          <div className="absolute top-0 left-0 right-0 p-4 flex justify-between items-center bg-black bg-opacity-50 z-10">
            <div className="flex items-center gap-6 ml-4">
              <button onClick={handleZoomOut} className="text-white hover:text-blue-400 transition-colors text-2xl font-bold px-2">-</button>
              <span className="text-white font-sans min-w-[3rem] text-center">{Math.round(zoomLevel * 100)}%</span>
              <button onClick={handleZoomIn} className="text-white hover:text-blue-400 transition-colors text-2xl font-bold px-2">+</button>
            </div>
            <button onClick={handleCloseEnlarged} className="text-white hover:text-red-400 transition-colors mr-4">
              <RxCross2 size={32} />
            </button>
          </div>

          {/* Image Container */}
          <div className="w-full h-full overflow-auto flex items-center justify-center p-4 custom-scrollbar">
            <img 
              src={selectedImage} 
              alt="Enlarged" 
              className="max-w-full max-h-full transition-transform duration-200 ease-out rounded-lg shadow-2xl" 
              style={{ 
                transform: `scale(${zoomLevel})`,
                transformOrigin: 'center'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageModal;